import { render, staticRenderFns } from "./TabListProductLink.vue?vue&type=template&id=d2da5164&scoped=true&"
import script from "./TabListProductLink.vue?vue&type=script&lang=js&"
export * from "./TabListProductLink.vue?vue&type=script&lang=js&"
import style0 from "./TabListProductLink.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TabListProductLink.vue?vue&type=style&index=1&id=d2da5164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2da5164",
  null
  
)

export default component.exports